<template>
    <div class="p10" v-loading.body="loading">
        <!-- 头部按钮部分 start -->
        <div class="el-row ly-bill-title">
            <el-col :span="6">
                <h1>{{title}}</h1>
            </el-col>
            <el-col :span="18" class="tr">
                <!-- 有操作项时 -->
                <template v-if="operType.length > 0">
                    <el-button type="info" size="small" @click="submit">
                        <i class="fa fa-save"></i>&nbsp;提交
                    </el-button>
                    <el-button size="small" @click="setOperType('')">
                        <i class="fa fa-close"></i>&nbsp;取消
                    </el-button>
                </template>
                <template v-else>
                    <!-- 只有待开票状态下才有的按钮 -->
                    <template v-if="infoData.status == 1">
                        <!-- 第34批加入需求，待开票状态下可以作废 -->
                        <el-button type="danger" size="small" 
                            @click="invalidClick"
                            v-if="buttonsConfig.isInvalid">
                            <i class="fa fa-ban"></i> 作废
                        </el-button>
                        <el-button type="warning" size="small" 
                            @click="setOperType(operEnum.RETREAT)"
                            v-if="buttonsConfig.isRetreat">
                            <i class="fa fa-reply"></i> 财务退回
                        </el-button>
                        <el-button type="success" size="small" 
                            @click="setOperType(operEnum.BILLING)"
                            v-if="buttonsConfig.isBilling">
                            <i class="fa fa-file-powerpoint-o"></i> 开票
                        </el-button>
                    </template>
                    <!-- 待开票和财务退回 可修改 -->
                    <template v-if="infoData.status == 1 || infoData.status == 21">
                        <ly-router-button
                            size="small"
                            :route="'/bill/invoice/edit/' + infoId"
                            type="primary"
                            v-if="buttonsConfig.isEdit">
                                <i class="fa fa-edit"></i>&nbsp;修改
                        </ly-router-button>
                    </template>
                    
                    <!-- 已开票状态下显示的按钮-->
                    <template v-if="infoData.status == 2">
                        <el-button type="info" size="small" 
                            @click="setOperType(operEnum.FP_EDIT)"
                            v-if="buttonsConfig.isFpedit">
                            <i class="fa fa-edit"></i> 发票修改
                        </el-button>
                        <el-button type="success" size="small" 
                            @click="setOperType(operEnum.FP_GET)"
                            v-if="buttonsConfig.isFpget">
                            <i class="fa fa-hand-paper-o"></i> 发票领取
                        </el-button>
                    </template>
                    <!-- 已开票和已领取状态下 可以作废 -->
                    <template v-if="infoData.status == 2 || infoData.status == 22">
                        <el-button type="danger" size="small" 
                            @click="setOperType(operEnum.FP_INVALID)"
                            v-if="buttonsConfig.isFpinvalid">
                            <i class="fa fa-ban"></i> 发票作废
                        </el-button>
                    </template>
                    <ly-router-button size="small">
                        <i class="fa fa-chevron-left"></i>&nbsp;返回
                    </ly-router-button>
                </template>     
            </el-col>
        </div>
        <!-- 头部按钮部分  end  -->
        <el-card class="box-card mt15">
            <el-row>
                <el-col :span="12">
                    <el-button-group>
                        <template v-if="infoData.last_id && infoData.last_id > 0">
                            <el-button type="info" size="small" @click="toggoleInfo(infoData.last_id)">
                                <i class="fa fa-chevron-left"></i> 前一张
                            </el-button>
                        </template>
                        <template v-if="infoData.next_id && infoData.next_id > 0">
                            <el-button type="info" size="small" @click="toggoleInfo(infoData.next_id)">
                                后一张 <i class="fa fa-chevron-right"></i> 
                            </el-button>
                        </template>
                    </el-button-group>
                </el-col>
                <el-col :span="12" class="tr">
                    <el-tag type="primary" v-if="infoData.status == 1">待开票</el-tag>
                    <el-tag type="success" v-else-if="infoData.status == 2">开票完成</el-tag>
                    <el-tag type="success" v-else-if="infoData.status == 22">发票已领取</el-tag>
                    <el-tag type="warning" v-else-if="infoData.status == 21">财务退回</el-tag>
                    <el-tag type="danger" v-else-if="infoData.status == 11">发票作废</el-tag>
                    <el-tag type="danger" v-else-if="infoData.status == 12">已作废</el-tag>
                </el-col>
            </el-row>
            <!-- 单据信息 start -->
            <ly-information 
                :config="infoConfig"
                :data="infoData"
                class="mt15">        
            </ly-information>
            <!-- 单据信息 end -->
        </el-card>
        <!-- 货品列表信息 start -->
        <div>
            <ly-table 
                :head="productConfig.head" 
                :data="infoData.productList" 
                :config="productConfig.config"
                class="mt15"
                v-if="productConfig.isExist != false">
            </ly-table>
            <div class="ly-info-product_total">
                合计：<span class="f14 bold">{{infoData.total_amount}}</span>
            </div>
        </div>
        <!-- 货品列表信息  end  -->
        <!-- 财务开票信息 start -->
        <invoice-billing 
            class="mt15" 
            :info-id="infoId"
            :info="infoData.invoicedeal_info"
            :type="isBilling.type"
            v-if="isBilling.bool"
            ref="billing">
        </invoice-billing>
        <!-- 财务开票信息  end  -->
        <!-- 发票领取 start -->
        <invoice-recive 
            class="mt15" 
            :info-id="infoId"
            :info="infoData.invoicedeal_info"
            :type="isRecive.type"
            :user-info="userInfo"
            v-if="isRecive.bool"
            ref="recive">
        </invoice-recive>
        <!-- 发票领取  end -->
        <!-- 财务退回信息  start -->
        <invoice-retreat 
            class="mt15" 
            :info-id="infoId"
            :info="infoData.invoicedeal_info"
            :type="isRetreat.type"
            v-if="isRetreat.bool"
            ref="retreat">
        </invoice-retreat>
        <!-- 财务退回信息  end -->
        <!-- 财务作废信息  start -->
        <invoice-invalid 
            class="mt15" 
            :info-id="infoId"
            :info="infoData.invoicedeal_info"
            :type="isInvalid.type"
            v-if="isInvalid.bool"
            ref="invalid">
        </invoice-invalid>
        <!-- 财务作废信息  end -->
        <!-- 处理记录 start -->
        <el-card class="box-card mt15">
            <template slot='header'>
            <div>
                <span>处理记录</span>
            </div>
            </template>
            <p class="f12 mt10 ctext" v-for="el in infoData.history">
                {{el}}
             </p>
        </el-card>
        <!-- 处理记录 end -->
    </div>
</template>
<script>
    import LyRouterButton from '@c/router-button'
    import InfoConfig from './info-config'
    import LyInformation from '@c/information'
    import LyTable from '@c/table'
    // 开票
    import InvoiceBilling from './billing'
    // 领取
    import InvoiceRecive from './receive'
    // 退回
    import InvoiceRetreat from './retreat'
    // 作废
    import InvoiceInvalid from './invalid'

    import {mapGetters, mapActions} from 'vuex'
    export default {
        mixins: [
            InfoConfig
        ],
        components: {
            LyRouterButton,
            LyInformation,
            LyTable,
            InvoiceBilling,
            InvoiceRecive,
            InvoiceRetreat,
            InvoiceInvalid
        },
        data () {
            return {
                infoId: 0,
                operType: '', // 按钮操作类型
                operEnum: {
                    RETREAT: 'retreat', // 财务退回
                    BILLING: 'billing', // 开票
                    FP_EDIT: 'fpedit', // 发票修改
                    FP_INVALID: 'fpinvalid', // 发票作废,
                    FP_GET: 'fpget', // 发票领取
                    EDIT: 'edit' // 单据的修改
                }, // 操作类型的枚举
                loading: false,
                infoData: { // 详情信息的数据
                },
                buttonsConfig: {}
            }
        },
        computed: {
            ...mapGetters('route', [
                'currRoute'
            ]),
            ...mapGetters([
                'userInfo'     
            ]),
            /**
             * 是否显示财务开票信息
             * 1、在待开票状态下的，开票操作需要显示 表单
             * 2、在已开票状态显示表格
             * 3、在作废状态下，如果有开票信息显示表格
             * 4、已开票下，点击了发票修改，显示表单
             */
            isBilling () {
                let bool = false // 是否显示
                let type = 'show' // 显示类型
                if (this.infoData.status === 1 && this.operType === this.operEnum.BILLING) {
                    bool = true
                    type = 'edit'
                } else if (this.infoData.status === 2 && this.operType !== this.operEnum.FP_GET) {
                    bool = true
                    if (this.operType === this.operEnum.FP_EDIT) {
                        type = 'update'
                    }
                } else if (this.infoData.status === 11 && this.infoData.invoicedeal_info) {
                    let obj = this.infoData.invoicedeal_info
                    // 区分已开票和已领取的状态
                    if ((obj.finance_work_time && obj.finance_work_time.length > 0) && 
                        (!obj.received_name || obj.received_name.length < 1)) {
                        bool = true
                    }
                }
                return {bool, type, ref: 'billing'}
            },
            /**
             * 是否显示发票领取信息
             * 1、已开票状态，点击发票领取，显示表单
             * 2、已领取状态，显示表格
             * 3、在作废状态下，如果有领取信息，显示表格
             */
            isRecive () {
                let bool = false // 是否显示
                let type = 'show' // 显示类型
                if (this.infoData.status === 2 && this.operType === this.operEnum.FP_GET) {
                    bool = true
                    type = 'edit'
                } else if (this.infoData.status === 22) {
                     bool = true
                } else if (this.infoData.status === 11 && this.infoData.invoicedeal_info) {
                    let obj = this.infoData.invoicedeal_info
                    // 区分已开票和已领取的状态
                    if ((obj.finance_work_time && obj.finance_work_time.length > 0) && 
                        (obj.received_name || obj.received_name.length > 0)) {
                        bool = true
                    }
                }
                return {bool, type, ref: 'recive'}
            },
            /**
             * 是否显示财务退回信息
             * 1、待开票状态，点击财务退回，显示表单
             * 2、退票状态，显示表格
             */
            isRetreat () {
                let bool = false // 是否显示
                let type = 'show' // 显示类型
                if (this.infoData.status === 1 && this.operType === this.operEnum.RETREAT) {
                    bool = true
                    type = 'edit'
                } else if (this.infoData.status === 21) {
                    bool = true
                }
                return {bool, type, ref: 'retreat'}
            },
            /**
             * 是否显示财务作废信息
             * 1、已开票状态下，点击了作废操作，显示表单
             * 2、已领取状态下，点击了作废操作，显示表单
             * 3、作废状态下，显示表格
             */
            isInvalid () {
                let bool = false // 是否显示
                let type = 'show' // 显示类型
                if ((this.infoData.status === 2 || this.infoData.status === 22) && 
                    this.operType === this.operEnum.FP_INVALID) {
                    bool = true
                    type = 'edit'
                } else if (this.infoData.status === 11) {
                    bool = true
                }
                return {bool, type, ref: 'invalid'}
            },
            title () {
                let txt = '发票登记'
                if (this.isBilling.bool && this.isBilling.type === 'update') {
                    txt = '发票登记发票修改'
                } else if (this.isRecive.bool && this.isRecive.type === 'edit') {
                    txt = '发票领取'
                }
                return txt
            }
        },
        watch: {
            userInfo () {
                this.initData()
            },
            '$route' (to, from) {
                // 清空之前的输入
                if (to.name === 'InvoiceCheckinInfo') {
                    this.readRouteConfig()
                }
            }
        },
        created () {
            this.readRouteConfig()
        },
        methods: {
            ...mapActions('route', [
                'updateCurrRoute'
            ]),
            readRouteConfig () {
                // 获得当前页面的配置
                let routeConfig = this.$utils.readRouteConfig(this.$route.fullPath)
                // 更新当前路由对象
                this.updateCurrRoute(routeConfig)
                // 获得当前页面的配置
                let config = this.$utils.readPageConfig(this.currRoute, 'info')
                // 当前页面的组件配置
                config = config ? config.config : null
                if (config) {
                    // 获得按钮的配置
                    this.buttonsConfig = JSON.parse(config.button || '[]')
                }
                this.queryInfoData()
            },
            /**
             * 获取详情的数据
             */
            queryInfoData () {
                this.loading = true
                this.infoId = this.$route.params.id
                this.$api.query('api/invoice', null, [this.infoId]).then((rs) => {
                    this.loading = false
                    this.infoData = rs
                }).catch((error) => {
                    this.loading = false
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
            /**
             * 设置操作类型
             */
            setOperType (type) {
                this.operType = type
            },
            /**
             * 数据的提交
             */
            submit () {
                let boolObj // 当前控制编辑显示的对象
                // 控制显示的变量集合
                [this.isBilling, this.isRecive, this.isRetreat, this.isInvalid].forEach((v) => {
                    if (v.bool && v.type !== 'show') {
                        boolObj = this.$refs[v.ref]
                    }
                })
                if (boolObj && boolObj.submit) {
                    boolObj.submit(() => {
                        this.$alert('数据提交成功', '提示', {
                            confirmButtonText: '确定',
                            callback: action => {
                                this.setOperType('') // 设置无操作类型
                                this.queryInfoData() // 重新获得详情数据
                            }
                        });
                    })
                }
            },
            /**
             * 路由跳转处理
             * @param  {[type]} path [description]
             * @return {[type]}      [description]
             */
            routerJump (path) {
                path = path.replace('#', '')
                this.loading = true
                this.$router.push(path)
            },
            /**
             * 详情页面的切换
             */
            toggoleInfo (id) {
                // 跳转到的路由
                let path = '/bill/' + this.currRoute.path + '/info/' + id
                this.routerJump(path)
            },
            /**
             * 待处理状态下的作废
             */
            invalidClick () {
                this.$confirm('确定要作废?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$api.create('api/invoicecancel', {
                        id: this.infoId,
                        type: 23
                    }).then(() => {
                        this.$message({
                            type: 'success',
                            message: '作废成功!'
                        })
                        this.queryInfoData()
                    }).catch((err) => {
                        this.$message({
                            type: 'warning',
                            message: err
                        })
                    })
                }).catch(() => {})
            }
        }
    }
</script>
<style>
    .ly-info-product_total {
        border:1px solid #dfe6ec;
        border-top: 0;
        color: #48576a;
        font-size: 14px;
        padding: 8px 10px;
        text-align: right;
    }
</style>